import Button from "components/core/Button/Button";
import React from "react";
import { useAuth } from "source/hooks";
import styles from "./StartEarningPerksCTA.module.scss";

type Props = {};

const StartEarningPerksCTA = (props: Props) => {
  const auth = useAuth();

  return (
    <div className={styles.container}>
      <h2 className={styles.text}>
        Start earning perks <span>today</span>
      </h2>
      <Button onClick={() => auth.smsSignUp()} arrow>
        Join Now
      </Button>
    </div>
  );
};

export default StartEarningPerksCTA;
